/* eslint-disable */
/* DO NOT edit of format these scripts, they should be pasted from provider
 * These scripts come from third parties for tracking
 * They are injected in the page <head> using vue-helmet
 * Linter is disabled because these are third party scripts meant for HTML
*/

const capterraScript = `(function () {
    var capterra_vkey = '01d219347986d5696d9d73c724b44ffb',
    capterra_vid = '2121648',
    capterra_prefix = 'https://ct.capterra.com';
    var ct = document.createElement('script');
    ct.type = 'text/javascript';
    ct.async = true;
    ct.src = capterra_prefix + '/capterra_tracker.js?vid='
    + capterra_vid + '&vkey=' + capterra_vkey;
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ct, s);
    })();`;

const googleTagManager = (page) => `
  // - The following script is used to activate Google Analytics tracking
  (function (i, s, o, g, r, a, m) {
    i.GoogleAnalyticsObject = r; i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date(); a = s.createElement(o),
    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m);
  }(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga'));

  ga('create', 'UA-43819347-1', 'auto');
  /* Hard-code location so the query string isn't passed into tracking */
  ga('set', 'location', 'https://console.jumpcloud.com/${page}');
  ga('send', 'pageview');
`;

const pardotScript = `
  piAId = '877401';
  piCId = '52448';
  piHostname = 'pi.pardot.com';
  (function() {
    function async_load(){
      var s = document.createElement('script'); s.type = 'text/javascript';
      s.src = ('https:' == document.location.protocol ? 'https://pi' : 'http://cdn') + '.pardot.com/pd.js';
      var c = document.getElementsByTagName('script')[0]; c.parentNode.insertBefore(s, c);
    }
    if(window.attachEvent) { window.attachEvent('onload', async_load); }
    else { window.addEventListener('load', async_load, false); }
  })();
`;

const redditPixel = '!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt(\'init\',\'t2_25j2zqqe\');rdt(\'track\', \'PageVisit\');rdt(\'track\', \'SignUp\');';

export default { capterraScript, googleTagManager, pardotScript, redditPixel };
